export default "/images/filter.png?cb1a0f188d7f4724019dfa3a5889b234";